import {BaseConstants} from "../constants/BaseConstants";

function updatePrescriptions(prescriptions) {
    return {type: BaseConstants.PRESCRIPTIONS, value: prescriptions};
}

export const emrActions = {
    updatePrescriptions
}